import React, { useState } from 'react';

import type { ToolCall } from '../types';
import { CheckIcon, ChevronIcon } from '../icons';

/*
 * One tool-call pill. Compact by default: a spinner (started) or green check
 * (finished) + the friendly tool name. When there's a result summary the pill
 * is clickable and expands to reveal the full detail — backend summaries can be
 * long, so they are collapsed to keep the transcript readable.
 */

const humanize = (s: string) =>
  (s || '')
    .replace(/[_-]+/g, ' ')
    .replace(/^\w/, (c) => c.toUpperCase())
    .trim();

const ToolChip = ({ tool }: { tool: ToolCall }) => {
  const [open, setOpen] = useState(false);
  const label = humanize(tool.display || tool.name);

  if (tool.status !== 'finished') {
    return (
      <span className="bra-chip">
        <span className="bra-spin" />
        <span className="bra-lbl">{label}</span>
      </span>
    );
  }

  const detail = tool.result_summary?.trim();
  const hasDetail = Boolean(detail);

  return (
    <div className="bra-chipwrap">
      <button
        type="button"
        className={`bra-chip bra-done${hasDetail ? ' bra-clickable' : ''}`}
        onClick={hasDetail ? () => setOpen((o) => !o) : undefined}
        aria-expanded={hasDetail ? open : undefined}
      >
        <CheckIcon className="bra-ok" width={13} height={13} />
        <span className="bra-lbl">{label}</span>
        {hasDetail ? (
          <ChevronIcon
            className="bra-chev"
            width={13}
            height={13}
            style={{ transform: open ? 'rotate(180deg)' : undefined }}
          />
        ) : null}
      </button>
      {hasDetail && open ? (
        <div className="bra-chipdetail">{detail}</div>
      ) : null}
    </div>
  );
};

export default ToolChip;
